import { theme } from 'antd';
import type { CSSProperties } from 'react';

/**
 * Card look for the download drawers' checkbox options. antd's `Checkbox.Group` has no styles
 * prop and `Checkbox` has no component tokens for this, so each option takes the style.
 * The label colour is left to antd's native disabled styling.
 */
const useCheckboxCardStyle = (): ((disabled?: boolean) => CSSProperties) => {
  const { token } = theme.useToken();

  return (disabled = false) => ({
    padding: token.paddingSM,
    margin: 0,
    borderRadius: token.borderRadiusLG,
    border: `1px solid ${token.colorBorder}`,
    background: disabled ? token.colorBgContainerDisabled : undefined,
  });
};

export default useCheckboxCardStyle;
